import React, { useEffect } from 'react';
import t from 'react-translate';

// components
import { Button } from 'react-bootstrap';
import { config } from '@config/pendo.config.json';
import { sharedStyles } from '../styles';
import AICharacterVoice from './ai-character-voice';
import BackRoleplayDetailsButton from './back-roleplay-details-button';
import {
  AICharacterIcon,
  AIPersonality,
  AIRoleAndName,
} from './ai-character-utils';

export type CharacterEditModalProps = {
  onBackToRolePlay?: () => void;
};

const AICharacterEditView = (props: CharacterEditModalProps) => {
  const { onBackToRolePlay } = props;

  useEffect(() => {
    const modalBody = document.querySelector<HTMLElement>(
      '.ai-role-play-config-modal, .ai-role-play-edit-modal',
    );

    modalBody?.scrollTo({ top: 0 });
  }, []);

  return (
    <div css={sharedStyles}>
      <BackRoleplayDetailsButton
        onBackToRolePlay={onBackToRolePlay}
      />
      <AICharacterIcon />
      <AIRoleAndName />
      <AIPersonality />
      <AICharacterVoice />
      <div className='d-flex justify-content-center py-7'>
        <Button
          variant='primary'
          onClick={onBackToRolePlay}
          data-qa={config.pendo.activities.aiRolePlay.configModal.editCharacterDone}
        >
          {t.FORM.DONE()}
        </Button>
      </div>
    </div>
  );
};

export default AICharacterEditView;
